import { EMPTY_FIELD } from 'constants/emptyField';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useRecordContext } from 'react-admin';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { DateTimeField, FunctionField } from 'shared/react-admin/Fields';
import { CurrencyAmountField } from 'shared/react-admin/Fields/CurrencyAmountField/CurrencyAmountField';

export function LimitsShowTable(): JSX.Element {
  const record = useRecordContext();
  const translate = useTypedTranslate();
  const currency = record?.currency;

  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '226px' } } }}>
      <TableRowWrapper label={translate('app.limits.currency')}>
        <FunctionField render={() => `${currency?.alphaCode} / ${currency?.name}`} />
      </TableRowWrapper>

      <TableRowWrapper label={translate('app.limits.minDepositAmount')}>
        <CurrencyAmountField currencyAlphaCode={currency?.alphaCode} source="paymentMin" />
      </TableRowWrapper>

      <TableRowWrapper label={translate('app.limits.maxDepositAmount')}>
        <CurrencyAmountField currencyAlphaCode={currency?.alphaCode} source="paymentMax" />
      </TableRowWrapper>

      <TableRowWrapper label={translate('app.limits.minWithdrawalAmount')}>
        <CurrencyAmountField currencyAlphaCode={currency?.alphaCode} source="payoutMin" />
      </TableRowWrapper>

      <TableRowWrapper label={translate('app.limits.maxWithdrawalAmount')}>
        <CurrencyAmountField currencyAlphaCode={currency?.alphaCode} source="payoutMax" />
      </TableRowWrapper>

      <TableRowWrapper label={translate('app.limits.createdAt')}>
        <DateTimeField emptyText={EMPTY_FIELD} inline source="createdAt" />
      </TableRowWrapper>

      <TableRowWrapper label={translate('app.limits.updatedAt')}>
        <DateTimeField emptyText={EMPTY_FIELD} inline source="updatedAt" />
      </TableRowWrapper>
    </CardTable>
  );
}
